import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { cn } from '@/utils/styles';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';

interface LongvietyCardsLgProps {
  mainText: string;
  isMainTextPercentage?: boolean;
  subText: string;
  subTextColor?: string;
  title?: string;
  footer?: string;
  overlayImg?: string;
  videoSrc?: any;
  additionalText?: string;
  videoHeight: string;
  inflammagingAddonClasses?: { videoFrameHeight: string; relativeTop: string };
  onClick?: () => void;
}

export const LongvietyCards: React.FC<LongvietyCardsLgProps> = ({
  title,
  isMainTextPercentage,
  mainText,
  subText,
  subTextColor,
  overlayImg,
  videoSrc,
  additionalText,
  footer,
  videoHeight,
  inflammagingAddonClasses,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className="w-full h-full border-[1.6px] rounded-lg border-stroke-static cursor-pointer select-none"
    >
      <div
        className={cn(
          'relative mt-8',
          inflammagingAddonClasses && inflammagingAddonClasses.videoFrameHeight,
        )}
      >
        <h2
          className={cn(
            'absolute top-1 z-10 w-full text-center typography-h4 text-primary',
          )}
        >
          {title}
        </h2>
        {videoSrc && (
          <div
            className={cn(
              'relative',
              videoHeight,
              inflammagingAddonClasses && inflammagingAddonClasses.relativeTop,
            )}
          >
            <div className="absolute inset-0 overflow-hidden">
              <Player
                autoplay
                loop
                src={videoSrc}
                className="rounded-lg object-cover"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  height: '100%',
                  width: '100%',
                }}
              />
            </div>
            {overlayImg && (
              <div className="absolute inset-0 mt-4 lg:mt-4 max-sm:mt-0 flex flex-col justify-center items-center">
                <img
                  src={overlayImg}
                  alt={mainText || 'overlay'}
                  className="w-full max-h-[14rem] xl:max-h-[14rem] max-sm:h-[12rem] object-contain pointer-events-none"
                />
              </div>
            )}
            <div
              className={cn(
                'absolute inset-0 flex flex-col justify-center items-center',
                additionalText
                  ? 'mt-12 lg:mt-8 max-sm:mt-4'
                  : 'mt-10 lg:mt-8 max-sm:mt-6',
              )}
            >
              <p
                className={cn(
                  'dark text-primary font-serif',
                  isMainTextPercentage
                    ? 'max-sm:typography-h5 typography-num-large'
                    : 'typography-h5',
                )}
              >
                {mainText}
              </p>
              <p
                className={cn(
                  'dark typography-body text-primary',
                  additionalText ? 'mt-2' : 'mt-4',
                )}
                style={{ color: subTextColor }}
              >
                {subText}
              </p>
              <p className="dark typography-caption1 mt-1 text-[#A0A1AD]">
                {additionalText}
              </p>
            </div>
          </div>
        )}
      </div>
      <p
        className="typography-body flex flex-row text-secondary px-8 mb-8 overflow-hidden"
        style={{
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 3,
        }}
      >
        {footer}
        <ChevronRightIcon className="inline ml-1 pb-0.5" />
      </p>
    </div>
  );
};
